//таблица на странице "Категории"
import { DeleteOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Switch, Table, Tooltip } from "antd";
import Compact from "antd/es/space/Compact";
import { useMemo } from "react";
import EditCategory from "src/features/Modal/ui/EditCategory";
import { EditableCell, EditableRow, PhotoCell } from "src/shared";
import { setColumnCellProps } from "../lib/setCollumnCellProps";
import { COL_CATEGORIES } from "../model/constants";

export default function Categories({
  handleRemove,
  handleSave,
  dataSource,
  token,
  messageApi,
}) {
  const columns = useMemo(
    () =>
      setColumnCellProps(COL_CATEGORIES, {
        image: [
          {
            key: "render",
            action: (_, record) => (
              <PhotoCell
                entity="categories"
                entityId={record.id}
                token={token}
                size={45}
                messageApi={messageApi}
              />
            ),
          },
        ],
        name: [
          {
            key: "render",
            action: (record) => (
              <Tooltip placement="topLeft" title={record}>
                {record}
              </Tooltip>
            ),
          },
        ],
        description: [
          {
            key: "render",
            action: (record) => (
              <Tooltip placement="topLeft" title={record}>
                {record}
              </Tooltip>
            ),
          },
        ],
        status: [
          {
            key: "render",
            action: (checked, record) => (
              <>
                <Switch
                  checked={checked}
                  onChange={(checked) => {
                    record.status = checked;
                    handleSave(record);
                  }}
                />
              </>
            ),
          },
        ],
        action: [
          {
            key: "render",
            style: { padding: "0" },
            action: (_, record) => (
              <Compact
                style={{
                  padding: "0",
                }}
              >
                <EditCategory
                  record={record}
                  handleSave={handleSave}
                  token={token}
                />
                <Tooltip title={"Удалить категорию"}>
                  <Popconfirm
                    title={"Подтвердите удаление"}
                    onConfirm={() => handleRemove(record.id)}
                  >
                    <Button icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Tooltip>
              </Compact>
            ),
          },
          {
            key: "onCell",
            action: () => ({ style: { padding: 0 } }), // Убираем padding у ячеек колонки "Действие"
          },
        ],
      }),
    [handleRemove, handleSave, token, messageApi]
  );

  return (
    <>
      <Table
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={dataSource}
        components={{
          body: {
            cell: EditableCell,
            row: EditableRow,
          },
        }}
        bordered
        rowClassName={() => "editable-row"}
        style={{ width: "100%" }}
      />
    </>
  );
}
